module.exports = __webpack_public_path__ + "static/img/packBack.7f86fd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packBack.jpg
// module id = 9ome
// module chunks = 0